import React, { useState, useEffect } from "react";
import Category from "../components/Category";
import HeroSlide from "../components/HeroSlide";
import ProductSlide from "../components/ProductSlide";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl"; // Ensure imgurl is imported
import CategoryMobile from "../components/CategoryMobile";
import ProductCardSlideMobile from "./HomeCompo/ProductCardSlideMobile";

function Terms() {
  
    return (
     <>
     
     <section className="container my-5">
       <h1>Terms & Conditions</h1>
    <p><strong>Subcity International Marketing Pvt Ltd</strong></p>
    <p><strong>Effective Date:</strong> 02/02/2026<br/>
    <strong>Last Updated:</strong> 02/02/2026</p>

    <p>Welcome to the official website of Subcity International Marketing Pvt Ltd (“Company”, “we”, “our”, “us”). These Terms & Conditions govern your access to and use of our e-commerce website and services.</p>
    
    <p>By accessing, browsing, or purchasing from our website, you agree to be bound by these Terms & Conditions.</p>

    <hr/>

    <h2>1. Eligibility</h2>
    <ul>
        <li>You must be 18 years or older to use this website.</li>
        <li>By using this website, you confirm that the information provided by you is true and accurate.</li>
    </ul>

    <h2>2. Account Registration</h2>
    <ul>
        <li>You may be required to create an account to place orders.</li>
        <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        <li>The Company shall not be liable for any loss caused due to unauthorized access to your account.</li>
    </ul>

    <h2>3. Product Information</h2>
    <ul>
        <li>Product images are for illustrative purposes only.</li>
        <li>Actual product color, size, or packaging may vary.</li>
        <li>Product availability is subject to stock.</li>
    </ul>

    <h2>4. Pricing & Payment</h2>
    <ul>
        <li>All prices are listed in Indian Rupees (INR) and inclusive/exclusive of GST as mentioned.</li>
        <li>Prices may change without prior notice.</li>
        <li>Payments are processed through secure RBI-authorized payment gateways.</li>
        <li>The Company does not store card details, CVV, or UPI PINs.</li>
    </ul>

    <h2>5. Order Acceptance & Cancellation</h2>
    <p>Orders are accepted only after successful payment confirmation. The Company reserves the right to cancel orders due to:</p>
    <ul>
        <li>Payment failure</li>
        <li>Incorrect pricing or product information</li>
        <li>Stock unavailability</li>
        <li>Suspected fraud</li>
    </ul>
    <p>Customers may cancel orders before dispatch only.</p>

    <h2>6. Shipping & Delivery</h2>
    <ul>
        <li>Delivery timelines are estimates and may vary based on location and logistics.</li>
        <li>The Company is not responsible for delays caused by courier partners, natural calamities, or force majeure events.</li>
    </ul>

    <h2>7. Returns & Refunds</h2>
    <ul>
        <li>Returns are accepted only for damaged, defective, or incorrect products.</li>
        <li>Return requests must be raised within 48 hours of delivery.</li>
        <li>Refunds will be processed within 7–10 working days after approval.</li>
        <li>Refunds will be credited to the original payment method.</li>
    </ul>
    <p>(Please refer to our Return & Refund Policy for detailed terms.)</p>

    <h2>8. User Conduct</h2>
    <p>You agree not to:</p>
    <ul>
        <li>Use the website for unlawful purposes</li>
        <li>Upload false, misleading, or offensive content</li>
        <li>Attempt to hack, disrupt, or misuse the website</li>
        <li>Violate any applicable Indian law</li>
    </ul>

    <h2>9. Intellectual Property</h2>
    <ul>
        <li>All website content including text, images, logos, designs, and trademarks are the exclusive property of Subcity International Marketing Pvt Ltd.</li>
        <li>Unauthorized use, copying, or reproduction is strictly prohibited.</li>
    </ul>

    <h2>10. Disclaimer</h2>
    <ul>
        <li>Products sold on this website are not intended to diagnose, treat, cure, or prevent any disease unless expressly stated.</li>
        <li>Users are advised to consult professionals before use where applicable.</li>
    </ul>

    <h2>11. Limitation of Liability</h2>
    <p>The Company shall not be liable for:</p>
    <ul>
        <li>Indirect or consequential damages</li>
        <li>Loss of data, profits, or business</li>
        <li>Delays beyond reasonable control</li>
    </ul>

    <h2>12. Third-Party Links</h2>
    <ul>
        <li>Our website may contain links to third-party websites.</li>
        <li>We are not responsible for the content, accuracy, or policies of such websites.</li>
    </ul>

    <h2>13. Governing Law & Jurisdiction</h2>
    <ul>
        <li>These Terms & Conditions shall be governed by the laws of India.</li>
        <li>Courts at Assam, India shall have exclusive jurisdiction.</li>
    </ul>

    <h2>14. Grievance Redressal Officer</h2>
    <p>As per Consumer Protection (E-Commerce) Rules, 2020:</p>
    <div class="contact-info">
        <strong>Grievance Officer:</strong> Md Helal Uddin<br/>
        <strong>Email:</strong> subcityinternational22@gmail.com<br/>
        <strong>Phone:</strong> 8638407127
    </div>
    <p>Complaints will be acknowledged within 48 hours and resolved within 30 days.</p>

    <h2>15. Contact Information</h2>
    <div class="contact-info">
        <strong>Subcity International Marketing Pvt Ltd</strong><br/>
        📍 Address: Vill Paliguri, Jagiroad, Morigaon, Assam – 782410, India<br/>
        📞 Mobile: 8638407127<br/>
        📧 Email: subcityinternational22@gmail.com
    </div>


<style>
    {`
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
        }
        h1, h2, h3 {
            color: #2c3e50;
        }
        .contact-info {
            background-color: #f9f9f9;
            padding: 15px;
            border-left: 5px solid #2c3e50;
            margin: 20px 0;
        }
        .warning {
            background-color: #fff3cd;
            padding: 10px;
            border-radius: 5px;
            display: inline-block;
        }
        ul {
            margin-bottom: 20px;
        }
    </style>
    `}
</style>
     </section>
     
     </> 
   
  );
}

export default Terms;